module.exports = __webpack_public_path__ + "img/doctor_step1.ad7c5214.png";